<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">
  <div class="cxq">

    <!-- Nav : quitter (la tentative se reprend plus tard) + progression -->
    <div class="cxq-nav">
      <button class="cxq-quit-btn" (click)="quit()">
        <i class="fa-solid fa-xmark"></i>
        <span translate>Quitter</span>
      </button>
      <div class="cxq-progress">
        <div class="cxq-progress-label">
          <span translate>Question</span> {{ question.index }}/{{ question.total }}
        </div>
        <div class="cxq-progress-track">
          <div class="cxq-progress-fill" [style.width.%]="progressPercent"></div>
        </div>
      </div>
    </div>

    <div class="cxq-body">

    <!-- Consigne (langue source) -->
    <div class="cxq-instruction mb-3" *ngIf="question.instruction">
      {{ question.instruction }}
    </div>

    <!-- Support de compréhension (texte ou audio, partagé entre plusieurs questions) -->
    <div class="cxq-support mb-3" *ngIf="question.support">
      <div class="cxq-support-text" *ngIf="question.support.translation">
        {{ question.support.translation }}
      </div>
      <div class="cxq-support-audio" *ngIf="question.support.audio">
        <button class="cxq-audio-btn" (click)="audioSrv.play(question.support.audio)">
          <i class="fa-solid fa-volume-high"></i>
          <span translate>Écouter</span>
        </button>
      </div>
      <img class="cxq-support-image" *ngIf="question.support.image" [src]="question.support.image | gameImage" alt=""/>
    </div>

    <!-- Titre éventuel -->
    <div class="cxq-title mb-2" *ngIf="question.title">
      {{ question.title }}
    </div>

    <!-- Énoncé (langue cible) -->
    <div class="cxq-question mb-3" *ngIf="question.translation">
      <!-- Phrase à trou : le [?] devient un emplacement visuel rempli par la réponse choisie -->
      <ng-container *ngIf="question.type === 'gap_fill'">
        <ng-container *ngFor="let part of gapParts; let last = last; trackBy: trackByIndex">
          <span>{{ part }}</span>
          <span class="cxq-gap" *ngIf="!last" [class.cxq-gap--filled]="selectedAnswer">{{ selectedAnswer?.translation }}</span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="question.type !== 'gap_fill'">
        {{ question.translation }}
      </ng-container>
    </div>

    <!-- Audio / image de la question -->
    <div class="d-flex justify-content-center mb-3" *ngIf="question.audio">
      <button class="cxq-audio-btn" (click)="audioSrv.play(question.audio)">
        <i class="fa-solid fa-volume-high"></i>
        <span translate>Écouter</span>
      </button>
    </div>
    <div class="d-flex justify-content-center mb-3" *ngIf="question.image">
      <img class="cxq-image" [src]="question.image | gameImage" alt=""/>
    </div>

    <!-- Saisie libre (word_translation) -->
    <div class="cxq-free-input mb-3" *ngIf="question.freeInput">
      <input
        type="text"
        class="cxq-input"
        [(ngModel)]="freeText"
        (keyup.enter)="submit()"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        placeholder="{{ 'Ta réponse…' | translate }}"/>
    </div>

    <!-- Choix -->
    <div class="cxq-answers mb-3" *ngIf="!question.freeInput">
      <div
        class="cxq-answer"
        *ngFor="let answer of question.answers; trackBy: trackByIndex"
        (click)="selectAnswer(answer)"
        [class.cxq-answer--selected]="selectedAnswer && answer.uniqid === selectedAnswer.uniqid">
        <ng-container *ngIf="answer.translation">{{ answer.translation }}</ng-container>
        <i class="fa-solid fa-volume-high" *ngIf="!answer.translation && answer.audio"></i>
      </div>
    </div>

    <!-- Actions : pas de retour arrière, pas de feedback -->
    <div class="cxq-actions">
      <button class="cxq-btn-skip" (click)="skip()" [disabled]="submitting" translate>
        Je ne sais pas
      </button>
      <button class="cxq-btn-next" (click)="submit()" [disabled]="!canSubmit" translate>
        Valider
      </button>
    </div>

    </div>

  </div>
</ng-container>
